
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .popup-schedule.q-ma-md
    .q-title.q-mb-sm {{person.name}} - 個人勤務予定表

    .qrcode(v-if="url != null && qrcode != null")
      a.qrcode-url(:href="url" target="_blank") リンク
      img.qrcode-img(:src="qrcode" alt="")
    .qrcode(v-else)
      .qrcode-url 読み込み中です...
      .qrcode-img

    .row.reverse.reverse-wrap
      q-btn.q-mx-sm(
        color="dark"
        flat
        v-close-overlay
      ) 閉じる

      q-btn.q-mx-sm(
        color="negative"
        flat
        @click="updateUrl"
      ) URL更新
</template>

<script>
import QRCode from 'qrcode'
import AxiosMixin from 'mixins/axios'

export default {
  mixins: [AxiosMixin],

  data() {
    return {
      visible: false,

      person: {},
      baseUrl: null,
      url: null,
      qrcode: null,
    }
  },

  methods: {
    async show(person) {
      this.person = person
      this.baseUrl = null
      this.url = null
      this.qrcode = null
      this.visible = true

      const {data} = await this.axios.get('/api/schedule/' + this.person.person_code)
      this.baseUrl = data.baseUrl

      let token = data.token
      if (token == null) {
        const {data} = await this.axios.post('/api/schedule/' + this.person.person_code)
        token = data
      }

      this.url = this.baseUrl + token
      this.qrcode = await QRCode.toDataURL(this.url)
    },

    hide() {
      this.visible = false
    },

    async updateUrl() {
      if (this.url == null) return
      try {
        await this.$q.dialog({
          title: '更新の確認',
          message: 'URLを更新すると以前のURLは使用できなくなります。よろしいですか？',
          ok:     {label: '更新',       color: 'negative'},
          cancel: {label: 'キャンセル', color: 'dark', flat: true},
        })

        const {data} = await this.axios.post('/api/schedule/' + this.person.person_code)

        this.url = this.baseUrl + data
        this.qrcode = await QRCode.toDataURL(this.url)

      } catch(e) {this.$handler(e)}
    },
  },
}
</script>

<style lang="sass">
.popup-schedule
  width: 340px

  .qrcode
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 2em

  .qrcode-url
    width: 300px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis


  .qrcode-img
    image-rendering: pixelated;
    width: 300px
    height: 300px
</style>
